export const projects = [
  {
    name: '30-Day Email Template Series' ,
    url: 'https://yaninatrekhleb.github.io/30days_of_Emails/',
    img: require('../images/projects-img/30-Day_Email_Template_Series.png'),
    date: 'Sep 2024 - Oct 2024',
    tags: [
      { name: 'html/css' },
      { name: 'email design' },
      { name: 'email marketing' },
    ],
  },
  {
    name: 'How can I help Ukraine?' ,
    url: 'https://yaninatrekhleb.github.io/standWithUkraine/',
    img: require('../images/projects-img/stand-with-Ukraine-img.png'),
    date: 'Mar 2022 - Mar 2022',
    tags: [
      { name: 'jQuery' },
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
   {
    name: 'Test assignment for Media.Monks company interview',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/projects-img/media-monks-desktop.gif',
    img: require('../images/projects-img/media-monks-test-assigment.png'),
    date: 'Feb 2022 - Mar 2022',
    tags: [
      { name: 'javascript' },
      { name: 'dom' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Birthday Reminder',
    url: 'https://yaninatrekhleb.github.io/birthday-reminder-react/',
    img: require('../images/projects-img/birthday-reminder-react.png'),
    date: 'Feb 2022 - Feb 2022',
    tags: [
      { name: 'react.js' },
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Food Menu',
    url: 'https://yaninatrekhleb.github.io/food-menu/',
    img: require('../images/projects-img/food-menu.png'),
    date: 'Dec 2021 - Dec 2021',
    tags: [
      { name: 'react.js' },
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Animated Banner',
    url: 'https://yaninatrekhleb.github.io/animated-banner-bootstrap/',
    img: require('../images/projects-img/tulip-banner.png'),
    date: 'Apr 2021 - Apr 2021',
    tags: [
      { name: 'landing page' },
      { name: 'bootstrap' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'To Do List Vue',
    url: 'https://yaninatrekhleb.github.io/to-do-list-vue/',
    img: require('../images/projects-img/to-do-list-vue.png'),
    date: 'Oct 2020 - Nov 2020',
    tags: [
      { name: 'vue.js' },
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Public API',
    url: 'https://yaninatrekhleb.github.io/public-api/',
    img: require('../images/projects-img/api-vue.png'),
    date: 'Aug 2020 - Sep 2020',
    tags: [
      { name: 'vue.js' },
      { name: 'javascript' },
      { name: 'html/css' },
      { name: 'api' },
    ],
  },
  {
    name: 'Weather App Vue',
    url: 'https://yaninatrekhleb.github.io/weatherApp-vueJs/',
    img: require('../images/projects-img/weather-vue.png'),
    date: 'Aug 2020 - Aug 2020',
    tags: [
      { name: 'vue.js' },
      { name: 'javascript' },
      { name: 'html/css' },
      { name: 'api' },
    ],
  },
  {
    name: 'Food Blog',
    url: 'https://yaninatrekhleb.github.io/food-blog-sass/',
    img: require('../images/projects-img/food-sass.png'),
    date: 'Jun 2020 - Jun 2020',
    tags: [
      { name: 'html/css' },
      { name: 'sass' },
      { name: 'landing page' },
    ],
  },
  {
    name: 'To Do List React',
    url: 'https://yaninatrekhleb.github.io/to-do-list/',
    img: require('../images/projects-img/to-do-list-react.png'),
    date: 'Apr 2020 - May 2020',
    tags: [
      { name: 'react.js' },
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Things to do on quarantine',
    url: 'https://yaninatrekhleb.github.io/quarantine-what-to-do/',
    img: require('../images/projects-img/quarantine-react.png'),
    date: 'Apr 2020 - Apr 2020',
    tags: [
      { name: 'react.js' },
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Tip Calculator',
    url: 'https://yaninatrekhleb.github.io/tip-calculator/index.html',
    img: require('../images/projects-img/tip-calculator.png'),
    date: 'Oct 2019 - Nov 2019',
    tags: [
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Restaurant Landing Page',
    url: 'https://yaninatrekhleb.github.io/restaurant-website/',
    img: require('../images/projects-img/restaurant-landing.png'),
    date: 'Sep 2019 - Sep 2019',
    tags: [
      { name: 'html/css' },
      { name: 'bootstrap' },
      { name: 'landing page' },
    ],
  },
  {
    name: 'Succulent Gallery',
    url: 'https://yaninatrekhleb.github.io/succulent-gallery/',
    img: require('../images/projects-img/gallery-css.png'),
    date: 'Feb 2020 - Feb 2020',
    tags: [
      { name: 'html/css' },
      { name: 'bootstrap' },
    ],
  },
  {
    name: 'Luhn algorithm - credit card validity checker',
    url: 'https://yaninatrekhleb.github.io/luhn-algorithm/index.html',
    img: require('../images/projects-img/luhn-algorithm.png'),
    date: 'Feb 2020 - Feb 2020',
    tags: [
      { name: 'javascript' },
      { name: 'algorithm' },
      { name: 'html/css' },
    ],
  },
  {
    name: '10 000 days Birthday',
    url: 'https://yaninatrekhleb.github.io/tenThousandDays/index.html',
    img: require('../images/projects-img/ten-thousand-days.png'),
    date: 'Dec 2019 - Dec 2019',
    tags: [
      { name: 'javascript' },
      { name: 'html/css' },
    ],
  },
  {
    name: 'Find a Pet Landing Page',
    url: 'https://yaninatrekhleb.github.io/adopt-a-pet/',
    img: require('../images/projects-img/adopt-a-pet.png'),
    date: 'Oct 2019 - Oct 2019',
    tags: [
      { name: 'html/css' },
      { name: 'bootstrap' },
      { name: 'landing page' },
    ],
  },
  {
    name: 'Wedding Agency Landing Page',
    url: 'https://yaninatrekhleb.github.io/wedding-agency-landing-page/',
    img: require('../images/projects-img/wedding-agency.png'),
    date: 'Sep 2020 - Sep 2020',
    tags: [
      { name: 'html/css' },
      { name: 'bootstrap' },
      { name: 'landing page' },
    ],
  },
  {
    name: 'Learn HTML and CSS from scratch. Practical Exercises',
    url: 'https://yaninatrekhleb.github.io/learn-html-css/',
    img: require('../images/projects-img/learn-html-css.png'),
    date: 'Sep 2019 - Sep 2019',
    tags: [
      { name: 'html/css' },
      { name: 'educational material' },
      { name: 'practice' },
    ],
  },
  {
    name: 'Sign Up Page Template',
    url: 'https://yaninatrekhleb.github.io/sign-up-page-template/',
    img: require('../images/projects-img/sign-up.png'),
    date: 'Jun 2019 - Jun 2019',
    tags: [
      { name: 'html/css' },
      { name: 'ui' },
    ],
  },
  {
    name: 'Blog Landing Page',
    url: 'https://yaninatrekhleb.github.io/blogger-website-template/',
    img: require('../images/projects-img/blogger-website.png'),
    date: 'Mar 2018 - Mar 2018',
    tags: [
      { name: 'html/css' },
      { name: 'ui' },
      { name: 'landing page' },
    ],
  },
  {
    name: 'Cooking blog',
    url: 'https://yaninatrekhleb.github.io/Yanina-s-cooking-blog/',
    img: require('../images/projects-img/cooking-css.png'),
    date: 'Feb 2018 - Feb 2018',
    tags: [
      { name: 'html/css' },
      { name: 'landing page' },
      { name: 'ui' },
    ],
  },
]